<template>
  <div
    class="category-list"
    :style="[
      themeStyle,
      backgroundImage,
    ]"
  >
    <div
      class="category-content"
      :style="{ width: configData.style.board.useboard ? `${configData.style.board.config['--content-margin']}%` : '90%' }"
    >
      <!-- 麵包屑導覽 -->
      <div class="category-breadcrumb">
        <div class="breadcrumb-wrapper">
          <b-breadcrumb>
            <b-breadcrumb-item :to="{name: 'home'}">
              <feather-icon
                icon="HomeIcon"
                size="16"
                class="align-text-top"
              />
            </b-breadcrumb-item>
            <b-breadcrumb-item
              v-for="item, index in breadcrumbData"
              :key="index"
              :active="item.active"
              :to="item.to"
            >
              {{ item.text }}
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
      <h2 class="pageName">
        {{ pageName }}
      </h2>
      <b-table
        ref="refCategoryTable"
        :items="categoryData"
        :fields="categoryTableColumns"
        borderless
        primary-key="cId"
        show-empty
        tbody-class="tbodyClass"
        tbody-tr-class="trClass"
        thead-class="hidden-header"
        class="m-0 category-table"
      >
        <!-- 忙碌中 -->
        <template #table-busy>
          <b-skeleton-table
            :rows="5"
            :columns="categoryTableColumns.length"
            :table-props="{ bordered: true, striped: true }"
            class="table-title"
          />
        </template>
        <!-- 查無資料 -->
        <template #empty>
          <div class="empty text-center my-5">
            <template-image
              v-if="configData.style.base.notFound && configData.style.base.notFound.image"
              :image-data="configData.style.base.notFound"
            />
            <span v-else>
              查無資料
            </span>
          </div>
        </template>

        <!-- 欄位: 名稱 -->
        <template #cell(name)="data">
          <router-link
            :title="data.item.name"
            :to="{
              name: 'class',
              params: {
                'category_name': data.item.name,
                'category_id': data.item.id,
              },
            }"
            class="category-title"
          >
            <!-- v-if="data.item.style.img.image.image" -->
            <div
              v-if="data.item.style && data.item.style.img.show"
              class="image-btn"
              :class="data.item.style.img.effectType"
            >
              <div v-if="data.item.style.img.effectType.includes('images')">
                <picture>
                  <source
                    :srcset="`${baseUrl}${webpImage(data.item.style.img.hoverImage.image)}`"
                    type="image/webp"
                  >
                  <b-img
                    :src="`${baseUrl}${data.item.style.img.hoverImage.image}`"
                    :alt="data.item.name"
                    class="hover-image"
                  />
                </picture>
              </div>
              <div
                class="w-100 h-100"
              >
                <picture>
                  <source
                    :srcset="`${baseUrl}${webpImage(data.item.style.img.image.image)}`"
                    type="image/webp"
                  >
                  <b-img
                    :src="`${baseUrl}${data.item.style.img.image.image}`"
                    :alt="data.item.name"
                    fluid
                    class="normal-image"
                  />
                </picture>
              </div>
            </div>
            <h3
              v-if="data.item.style && data.item.style.title.show"
              class="category-title-txt"
              :class="data.item.style ? data.item.style.title.effectType : ''"
              :style="[
                { color: data.item.style.title.color },
                { textShadow: data.item.style.title.effectType.includes('shadow') ? `0.1em 0.1em 0.05em ${data.item.style.title.shadow}` : 'none' }
              ]"
            >
              {{ shortenTxtLength(data.item.name) }}
            </h3>
            <h3
              v-if="!data.item.style"
              class="category-title-txt"
            >
              {{ shortenTxtLength(data.item.name) }}
            </h3>

          </router-link>
        </template>

        <!-- 欄位: 查看/回覆 -->
        <template #cell(total)="data">
          <div class="w-100 d-flex align-items-center">
            <div class="views">
              <span class="mr-50">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z" />
                </svg>
                {{ data.item.total.views ? data.item.total.views : 0 }}
              </span>
            </div>
            <div class="publish">
              <span class="mr-50">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M14.568.075c2.202 1.174 5.938 4.883 7.432 6.881-1.286-.9-4.044-1.657-6.091-1.179.222-1.468-.185-4.534-1.341-5.702zm7.432 10.925v13h-20v-24h8.409c4.857 0 3.335 8 3.335 8 3.009-.745 8.256-.419 8.256 3zm-16 5h5v-4h-5v4zm12 2h-12v1h12v-1zm0-3h-5v1h5v-1zm0-3h-5v1h5v-1z" />
                </svg>
                {{ data.item.total.articles ? data.item.total.articles : 0 }}
              </span>
            </div>
          </div>
        </template>

        <!-- 欄位: 最後發表 -->
        <template #cell(forums)="data">
          <div class="lastTags">
            <slick
              v-if="data.item.forums.length > 0"
              ref="slick"
              :options="slickOptions"
            >
              <div
                v-for="article in data.item.forums"
                :key="article.id"
                class="lastTag"
              >
                <router-link
                  v-b-tooltip.hover.focus.v-secondary
                  placement="bottom"
                  :title="article.title"
                  :to="{
                    name: 'article',
                    params: {
                      'article_name': article.title,
                      'article_id': article.id,
                    },
                  }"
                  class="d-block"
                  :style="{color: article.style ? article.style.color : ''}"
                >
                  {{ shortenTxtLength(article.title) }}
                </router-link>
                <div
                  v-b-tooltip.bottom.hover.focus.v-secondary
                  :title="`${dayjs(article.last_updated_at).format('YYYY-MM-DD HH:mm:ss')}`"
                  variant="gradient-primary"
                  class="updated-time"
                >
                  <span :style="{color: article.style ? article.style['date-color'] : ''}">
                    {{ updateOnline(article.last_updated_at) }}
                  </span>
                </div>
              </div>
            </slick>
            <div
              v-else
              class="lastTag"
            >
              <span class="empty">
                暫無文章
              </span>
            </div>
          </div>
        </template>

      </b-table>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BBreadcrumb, BBreadcrumbItem,
  BImg, BTable, BSkeletonTable, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Slick from 'vue-slick'

import dayjs from 'dayjs'

import TemplateImage from '../component/TemplateImage.vue'

import 'slick-carousel/slick/slick.css'

// import router from '@/router'

export default {
  components: {
    BImg,
    BBreadcrumb,
    BBreadcrumbItem,
    BTable,
    BSkeletonTable,

    TemplateImage,
    Slick,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    configData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      themeStyle: null,
      slickOptions: {
        autoplay: true,
        arrows: false,
        vertical: true,
        mobileFirst: true,
        // variableWidth: true,
      },
    }
  },
  computed: {
    baseUrl() {
      return this.$store.state.api.baseUrl
    },
    supportWebp() {
      return this.$store.state.app.supportWebp
    },
    windowWidth() {
      return this.$store.state.app.windowWidth
    },
    backgroundImage() {
      const bgImg = {}
      if (this.configData.style.board.useboard) bgImg.backgroundImage = `url(${this.baseUrl}${this.configData.style.board.mid.image})`
      else {
        bgImg.padding = '50px 0'
        bgImg.borderRadius = this.configData.style.board.config['--border-radius']
        bgImg.backgroundColor = this.configData.style.board.config['--board-bg-color']
        bgImg.borderColor = this.configData.style.board.config['--board-border-color']
        bgImg.borderStyle = this.configData.style.board.config['--board-border-style']
        bgImg.borderWidth = this.configData.style.board.config['--board-border-width']
      }
      return bgImg
    },
  },
  mounted() {
    this.themeStyle = this.configData.style.board.config
  },
  methods: {
    dayjs,
    // 時間格式
    updateOnline(time) {
      const createTime = Math.floor(new Date(time).getTime() / 1000)
      const createHour = String(new Date(time).getHours())
      const createMinute = String(new Date(time).getMinutes())
      const today = Math.floor(new Date().getTime() / 1000)
      const diffTime = today - createTime
      if (diffTime < 0) return '時間錯誤'
      // 定義單位時間
      const second = 1
      const minute = second * 60
      const hour = minute * 60
      const day = hour * 24
      // 定義換算時間
      let calcTime
      const secondCalc = parseInt(diffTime / second, 10)
      const minuteCalc = parseInt(diffTime / minute, 10)
      const hourCalc = parseInt(diffTime / hour, 10)
      const dayCalc = parseInt(diffTime / day, 10)
      if (dayCalc >= 1 && dayCalc <= 7) {
        if (dayCalc === 1) {
          calcTime = `昨天 ${createHour.padStart(2, '0')}:${createMinute.padStart(2, '0')}`
        } else if (dayCalc === 2) {
          calcTime = `前天 ${createHour.padStart(2, '0')}:${createMinute.padStart(2, '0')}`
        } else {
          calcTime = `${dayCalc} 天前`
        }
      } else if (hourCalc >= 1 && hourCalc <= 23) {
        calcTime = `${hourCalc} 小時前`
      } else if (minuteCalc >= 1 && minuteCalc <= 59) {
        calcTime = `${minuteCalc} 分鐘前`
      } else if (secondCalc >= 1 && secondCalc <= 59) {
        calcTime = `${secondCalc} 秒前`
      } else {
        calcTime = dayjs(time).format('YYYY-MM-DD HH:mm')
      }
      return calcTime
    },
    // (刪減)文字
    shortenTxtLength(txt) {
      if (!txt) return ''
      let resolve = txt
      if (txt.length > 12) {
        txt.substr(0, 12)
        resolve = `${txt.substr(0, 12)}...`
      }
      return resolve
    },
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
  },
  setup(props) {
    const refCategoryTable = ref(null)
    const categoryTableColumns = ref([
      {
        label: '標題', key: 'name', class: 'categoryTd categoryTitle text-nowrap', tdAttr: { thName: '標題' },
      },
      {
        label: '文章數', key: 'total', class: 'categoryTd categorySMTd', thClass: 'text-center', tdClass: '',
      },
      {
        label: '文章', key: 'forums', class: 'categoryTd categoryMDTd', thClass: 'text-center text-nowrap', tdAttr: { thName: '文章' },
      },
    ])
    const categoryTableBusy = ref(false)
    const refetchCategory = () => refCategoryTable.value.refresh()

    const pageName = ref('')
    const breadcrumbData = ref([])
    const categoryData = ref(null)

    const getCategoryConfig = () => {
      pageName.value = props.configData.style.board.title ? props.configData.style.board.title : '公告'
      categoryData.value = props.configData.data
      categoryData.value.map(category => {
        const newData = category
        const total = {
          articles: newData.forums.length,
          views: 0,
        }
        category.forums.forEach(articles => {
          total.views += articles.page_views
        })
        newData.total = total
        return newData
      })
      breadcrumbData.value.push({
        text: '論壇',
        to: { name: 'home' },
      })
      breadcrumbData.value.push({
        text: pageName.value,
        active: true,
      })
    }
    // #EE1B2E #33CCFF #EE5023 #3C9D40 #8F2A90

    getCategoryConfig()
    return {
      pageName,
      categoryData,
      breadcrumbData,

      refCategoryTable,
      categoryTableColumns,
      categoryTableBusy,

      refetchCategory,
      getCategoryConfig,
    }
  },
}
</script>
<style lang="scss">
$board-hover-color: var(--board-hover-color);
$board-table-border-color: var(--board-table-border-color);
$board-table-border-style: var(--board-table-border-style);
$board-table-border-width: var(--board-table-border-width);

.hidden-header {
  display: none;
}
.category-table{
  background-color: transparent !important;
}
table {
  position: relative;
  width:100%;
  // table-layout: fixed;
  // overflow: hidden;
  .rowClass{
    border-bottom: 1px dashed #A5CAE4;
  }
  .rowClass:last-child{
    border-bottom: 0px;
  }
  th {
    display: table-cell;
    padding: .25em .5em;
    padding: 1em;
    text-align: left;
    font-size: 18px;
  }

  td {
    display: table-cell;
    padding: .25em .5em;
    padding: 1em;
    text-align: left;
    font-size: 16px;
  }
}
.category-table{
  .trClass {
    display: flex;
    justify-content: start;
    border-bottom-color: $board-table-border-color;
    border-bottom-style: $board-table-border-style;
    border-bottom-width: $board-table-border-width;
    cursor: pointer;
    &:last-child {
      border-bottom-style: none;
    }
  }
  .trClass:hover {
    background-color: $board-hover-color;
  }
  .b-table-empty-row{
    display: flex;
    justify-content: center;
    &:hover {
      cursor: auto !important;
      background-color: transparent !important;
    }
  }
  .categoryTd {
    display: flex;
    align-items: center;
    padding: 8px;
    white-space: nowrap;
  }
  .categorySMTd, .categoryMDTd {
    padding: 8px 5px;
  }
}
@media screen and (max-width: 576px) {
  .category-table{
    .trClass {
      flex-direction: column;
    }
  }
}
@media screen and (max-width: 768px) {
  .category-table{
    .categoryTd {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px;
    }
    .categorySMTd {
      display: none;
    }
    .lastTag {
      text-align: center;
    }
  }
}
@media screen and (min-width: 767px) {
  .categoryTd {
    width: 60%;
  }
  .categorySMTd {
    width: 20%;
  }
  .categoryMDTd {
    width: 20%;
  }
  .lastTag{
    text-align: start;
    max-width: 250px;
  }
}
</style>

<style lang="scss" scoped>
$breadcrumb-color: var(--breadcrumb-color);
$board-color: var(--board-title-color);
$board-icon-publish-color: var(--board-icon-publish-color);
$board-icon-view-color: var(--board-icon-view-color);
$board-bg-color: var(--board-bg-color);
$board-mobile-bg-color: var(--board-mobile-bg-color);
$shadow-color: var(--shadow-color);
$shadow-inset-color: var(--shadow-inset-color);
$image-brightness: var(--images-brightness);
$link-color: var(--link-color);

a{
  &:hover {
    color: $link-color !important;
    text-decoration: none;
  }
}
.float:hover {
  transform: translateY(-5px);
}
.brightness:hover {
  filter: brightness(calc(calc(100 + var(--images-brightness)) * 1%));
}

.opacity:hover {
  opacity: calc(var(--images-opacity) * 1%);
}
.images:hover .normal-image{
  opacity:0;
}

.category-list{
  background-position: center;
  background-repeat: repeat-y;
  background-size: contain;
}

.category-content {
  position: relative;
  z-index: 100;
  height: 100%;
  width: calc(var(--content-margin) * 1%);
  min-height: 300px;
  margin: auto;
}
.category-breadcrumb {
  position: relative;
  left: 0;
  display: flex;
  margin-bottom: 1rem;
  .breadcrumb-item, .breadcrumb-item a{
    color: $breadcrumb-color;
  }
  .breadcrumb-item.active {
    color: $link-color;
  }
}
.pageName {
  position: relative;
  left: 0%;
  color: $board-color;
  margin-left: 1rem;
  // @media screen and (min-width: 991px) {
  //   left: 0;
  // }
}
.category-table{
  color: $board-color;
  border-radius: 1rem;
  .empty {
    user-select: none;
    text-align: center;
    color: $board-color;
  }
}

.category-title {
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 100%;
  cursor: pointer;
  .image-btn {
    position: relative;
    display: block;
    transition: .4s;
    img {
      // position: absolute;
      // top: 0;
      width: 100%;
      transition: .4s;
    }
    .hover-image {
      position: absolute;
      z-index: 1;
      top: 0;
    }
    .normal-image {
      position: relative;
      z-index: 1;
    }
  }
  .category-title-txt{
    position: relative;
    font-size: 20px;
    margin: 10px;
    color: $board-color;
    box-shadow: none !important;
    transition: 0.3s;
  }
  @media screen and (max-width: 575px) {
    flex-direction: column;
    .forum-title-txt {
      text-align: center;
      margin-top: 10px;
    }
  }

}
.lastTags {
  width: 100%;
  min-width: 125px;
}
.lastTag{
  font-size: 16px;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  a:visited{
    color:#666666;
  }
  .updated-time {
    font-size: 14px;
    @media screen and (min-width: 992px) {
      max-width: 120px;
    }
  }
}
.views{
  flex: 1;
  min-width: 50px;
  font-size: 14px;
  color: $board-icon-view-color;
  svg {
    width: 20px;
    height: 20px;
    fill: $board-icon-view-color;
  }
}
.publish{
  flex: 1;
  min-width: 50px;
  font-size: 14px;
  color: $board-icon-publish-color;
  svg {
    width: 20px;
    height: 20px;
    fill: $board-icon-publish-color;
  }
}

</style>
